export const LearnerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M19.9998 6L3.99976 33.7215H35.9998L19.9998 6Z"
      fill="#94DB98"
      stroke="#2F52EA"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.379 27.7089C16.379 27.7089 19.6195 29.7722 23.0246 27.6456"
      stroke="#2F52EA"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3605 23.0443C15.8429 23.0443 16.2339 22.6533 16.2339 22.1709C16.2339 21.6885 15.8429 21.2975 15.3605 21.2975C14.8781 21.2975 14.4871 21.6885 14.4871 22.1709C14.4871 22.6533 14.8781 23.0443 15.3605 23.0443Z"
      fill="#2F52EA"
    />
    <path
      d="M24.0376 23.0443C24.52 23.0443 24.911 22.6533 24.911 22.1709C24.911 21.6885 24.52 21.2975 24.0376 21.2975C23.5552 21.2975 23.1642 21.6885 23.1642 22.1709C23.1642 22.6533 23.5552 23.0443 24.0376 23.0443Z"
      fill="#2F52EA"
    />
    <path
      d="M13.2466 26.6899C16.05 26.6899 18.3226 24.4173 18.3226 21.6139C18.3226 18.8105 16.05 16.538 13.2466 16.538C10.4432 16.538 8.17065 18.8105 8.17065 21.6139C8.17065 24.4173 10.4432 26.6899 13.2466 26.6899Z"
      stroke="#2F52EA"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.1392 26.6899C28.9425 26.6899 31.2151 24.4173 31.2151 21.6139C31.2151 18.8105 28.9425 16.538 26.1392 16.538C23.3358 16.538 21.0632 18.8105 21.0632 21.6139C21.0632 24.4173 23.3358 26.6899 26.1392 26.6899Z"
      stroke="#2F52EA"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5886 21.6139C18.5886 21.6139 19.5886 20.7342 20.7975 21.6139"
      stroke="#2F52EA"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
